<template>
  <b-row>
    <b-col>
        <div class="text-right">
          <button type="button"
                  class="btn btn-sm fa fa-sync fa-lg btn-link"
                  @click="clearFilters">
          </button>
          <b-button class="btn-sm ml-2" v-b-tooltip.hover :title="$t('buttons.search')"
                    v-b-toggle.userdata_search_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
        </div>
        <div>
          <b-collapse id="userdata_search_collapse" class="mt-2">
            <CallLogFiltering :callLogRelatedContractorFilter="callLogRelatedContractorFilter" @getPage="getPage" ref="callLogFiltering"></CallLogFiltering>
          </b-collapse>
        </div>
        <Loader v-if="isLoading"></Loader>
        <span v-else-if="!isLoading && items.length < 1">{{ $t('views.excmcalllog.list.noItems') }}</span>
        <table v-else class="table table-sm table-striped table-hover">
          <thead>
          <tr>
            <th>{{$t('views.excmcalllog.list.callDateTime')}}</th>
            <th>{{$t('views.excmcalllog.list.idRelatedUserData')}}</th>
            <th>{{$t('views.excmcalllog.list.idHandlingUserData')}}</th>
            <th>{{$t('views.excmcalllog.list.phoneNumber')}}</th>
            <th>{{$t('views.excmcalllog.list.callDirection')}}</th>
            <th>{{$t('views.excmcalllog.list.answered')}}</th>
            <th>{{$t('views.excmcalllog.list.duration')}}</th>
            <th>{{$t('views.excmcalllog.list.description')}}</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="item in items"
            :key="item['@id']">
            <td>
              <span v-if="item.callDateTime">{{ $moment(item.callDateTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
            </td>
            <td>
              <router-link v-if="item.idRelatedUserData && item.idRelatedUserData.isCompany === 0" :to="{name: 'UserDataShow', params: { id: item.idRelatedUserData['@id'] }}">
                {{ item.idRelatedUserData.name }} {{ item.idRelatedUserData.surname }}
              </router-link>
              <router-link v-else-if="item.idRelatedUserData" :to="{name: 'FirmShow', params: { id: item.idRelatedUserData['@id'] }}">
                {{ item.idRelatedUserData.firmname1 === '' ? item.idRelatedUserData.fullName : item.idRelatedUserData.firmname1 }}
              </router-link>
            </td>
            <td>
              <router-link v-if="item.idHandlingUserData" :to="{name: 'UserDataShow', params: { id: item.idHandlingUserData['@id'] }}">
                {{ item.idHandlingUserData.name }} {{ item.idHandlingUserData.surname }}
              </router-link>
            </td>
            <td>
              <phoneNumberLink :phoneNumber="item.phoneNumber"/>
            </td>
            <td>
              <span v-if="item.callDirection === 0">{{$t('views.excmcalllog.list.callDirectionInbound')}}</span>
              <span v-else-if="item.callDirection === 1">{{$t('views.excmcalllog.list.callDirectionOutbound')}}</span>
            </td>
            <td>
              <i v-if="item.answered === 1" style="color: #28a745" class="fa fa-check-circle"></i>
              <i v-else class="fa fa-times-circle" style="color: #dc3545"></i>
            </td>
            <td>{{ item.duration }}</td>
            <td>{{ item.description }}</td>
            <td>
              <b-dropdown
                class="float-left"
                size="sm" variant="link"
                right text="Right align"
                toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                  <i class="fa fa-bars fa-lg"></i>
                </template>
                <b-dropdown-item
                  @click="showSetRelatedUserDataModal(item)">
                  <i class="fa fa-edit fa-lg"></i>
                  {{ $t('views.excmcalllog.list.setRelatedUserData') }}
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="item.idRelatedUserData"
                  @click="showCreatePhoneRelationModal(item)">
                  <i class="fa fa-plus fa-lg"></i>
                  {{ $t('views.excmcalllog.list.createPhoneRelation') }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="showSetDescriptionModal(item)">
                  <i class="fa fa-edit fa-lg"></i>
                  {{ $t('views.excmcalllog.list.setDescription') }}
                </b-dropdown-item>
              </b-dropdown>
            </td>
          </tr>
          </tbody>
        </table>
        <pagination
          v-if="view"
          :view="view"
          @getPage="getPage"
        ></pagination>
        <div class="float-right">
          <b-button v-if="downloadXlsStatus === 0" variant="info" @click="downloadXLS()" v-b-tooltip.hover :title="$t('buttons.downloadXLS')" class="float-left ml-2 mr-2 btn-circle">
            <i class="fal fa-file-spreadsheet"></i>
          </b-button>
          <b-button v-if="downloadXlsStatus === 1" variant="success" v-b-tooltip.hover :title="$t('buttons.downloadXLS')" class="float-left ml-2 mr-2 btn-circle">
            <i class="fal fa-spinner fa-spin"></i>
          </b-button>
        </div>
    </b-col>
    <updateCallLogRelatedUserDataModal v-if="updateCallLog" :update-call-log="updateCallLog" @reset="resetUpdateCallLog"/>
    <updateDescriptionModal v-if="updateCallLogDescription" :updateDescription="updateCallLogDescription" @reset="resetUpdateCallLog"/>
    <PhoneCreateModal v-if="idContractorToCreatePhone" :id-firm="idContractorToCreatePhone" :initialDateTime="initialDateTime" :initialDuration="initialDuration" />
  </b-row>
</template>
<script>
import CallLogFiltering from '@/components/Dashboard/Views/excmcalllog/components/CallLogFiltering'
import Loader from '../../Layout/Loader'
import Pagination from '../../Layout/Pagination'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import addParamsToQuery from '@/utils/addParamsToQuery'
import UpdateCallLogRelatedUserDataModal from '@/components/Dashboard/Views/excmcalllog/UpdateCallLogRelatedUserDataModal'
import PhoneCreateModal from '@/components/Dashboard/Views/excmrelation/modals/PhoneCreateModal'
import UpdateDescriptionModal from '@/components/Dashboard/Views/excmcalllog/UpdateDescriptionModal'
import PhoneNumberLink from '@/components/Dashboard/Views/firm/components/PhoneNumberLink'
import ApiService from '@/utils/ApiService'

export default {
  name: 'CallLogTable',
  components: { PhoneNumberLink, UpdateDescriptionModal, PhoneCreateModal, UpdateCallLogRelatedUserDataModal, CallLogFiltering, Loader, Pagination },
  data () {
    return {
      searchParams: {
        itemsPerPage: 10,
        state: 1,
        callLogRelatedContractorFilter: this.callLogRelatedContractorFilter
      },
      updateCallLog: null,
      updateCallLogDescription: null,
      initialDateTime: null,
      initialDuration: 0,
      idContractorToCreatePhone: null,
      downloadXlsStatus: 0
    }
  },
  created () {
    let url = addParamsToQuery('e_x_c_m_call_logs', this.searchParams)
    this.getPage(url)
  },
  methods: {
    ...mapActions({
      getPage: 'excmcalllog/list/default'
    }),
    ...mapMutations({
      togglePhoneModal: 'excmrelation/createModal/togglePhoneModal'
    }),
    showSetRelatedUserDataModal (item) {
      this.updateCallLog = { '@id': item['@id'], idRelatedUserData: item.idRelatedUserData ? item.idRelatedUserData['@id'] : null }
    },
    showSetDescriptionModal (item) {
      this.updateCallLogDescription = { '@id': item['@id'], description: item.description }
    },
    showCreatePhoneRelationModal (item) {
      this.idContractorToCreatePhone = item.idRelatedUserData['@id']
      this.initialDateTime = item.callDateTime
      this.initialDuration = this.hmsToSecondsOnly(item.duration)
      this.togglePhoneModal()
    },
    hmsToSecondsOnly (str) {
      let p = str.split(':')
      let s = 0
      let m = 1
      while (p.length > 0) {
        s += m * parseInt(p.pop(), 10)
        m *= 60
      }
      return s
    },
    async downloadXLS () {
      this.downloadXlsStatus = 1
      let params = Object.assign({}, this.$refs.callLogFiltering ? this.$refs.callLogFiltering.filters : this.searchParams)
      await new ApiService('e_x_c_m_call_logs/download_xls', params).downloadFile('call_logs.xls')
      this.downloadXlsStatus = 0
    },
    clearFilters () {
      if (this.$refs.callLogFiltering) {
        this.$refs.callLogFiltering.clearFilters()
      }
    },
    resetUpdateCallLog (withReload = false) {
      this.updateCallLog = null
      this.updateCallLogDescription = null
      if (withReload) {
        this.getPage(this.view['@id'])
      }
    }
  },
  computed: mapGetters({
    deletedItem: 'excmcalllog/del/deleted',
    error: 'excmcalllog/list/error',
    items: 'excmcalllog/list/items',
    isLoading: 'excmcalllog/list/isLoading',
    view: 'excmcalllog/list/view'
  }),
  props: {
    callLogRelatedContractorFilter: {
      type: String,
      default: ''
    }
  }
}
</script>
